import React from 'react';
import Code from './components/Code';
import './App.css';

const App = () => {
  return (
    <div id="root">
      <Code />
    </div>
  );
};

export default App;